module.exports = __webpack_public_path__ + "static/group-48-a07fd736e11e3804952239a019e7157a.svg";